export default __webpack_public_path__ + "static/media/ESSK34EMER01.01d3a793.mp4";